<section class="season-ranking-page">
  <app-admin-page-header
    [title]="season ? 'Ranking da temporada: ' + season.name : 'Ranking da temporada'"
    subtitle="Consulte a classificacao da temporada com filtros por usuario e faixa de posicao.">
    <div header-actions>
      <button class="admin-btn admin-btn--secondary" [routerLink]="['/dashboard/temporadas', seasonId]">
        Voltar para temporada
      </button>
    </div>
  </app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <div class="ranking-toolbar admin-surface">
    <label>
      <span>Usuario</span>
      <input
        class="admin-input"
        [(ngModel)]="searchTerm"
        (keydown.enter)="onSearchChange()"
        placeholder="Buscar por username" />
    </label>

    <label>
      <span>Posicao inicial</span>
      <input class="admin-input" type="number" min="1" [(ngModel)]="positionFrom" />
    </label>

    <label>
      <span>Posicao final</span>
      <input class="admin-input" type="number" min="1" [(ngModel)]="positionTo" />
    </label>

    <div class="ranking-toolbar__actions">
      <button class="admin-btn admin-btn--primary" (click)="onSearchChange()">Pesquisar</button>
      <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="admin-surface">
    <p-table
      [value]="ranking"
      [paginator]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalItems"
      [lazy]="true"
      [loading]="isLoading"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>Posicao</th>
          <th>ID Usuario</th>
          <th>Username</th>
          <th>Score</th>
          <th>Battle Score</th>
          <th>Vitorias</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-entry>
        <tr>
          <td>{{ entry.position }}</td>
          <td>{{ entry.user_id }}</td>
          <td>{{ entry.username }}</td>
          <td>{{ entry.score }}</td>
          <td>{{ entry.battle_score }}</td>
          <td>{{ entry.wins }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="ranking-empty">Nenhum jogador encontrado para os filtros selecionados.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
